import React from "react";
import BlogCard from "components/BlogCard";

/**
 * Thin wrapper so the dashboard can pass a blog object.
 * Visual design lives in BlogCard (Figma Multibagger_Article_Card).
 */
const FeaturedBlogCard = ({ blog, onReadMore }) => {
  if (!blog) {
    return null;
  }

  return (
    <BlogCard
      title={blog.title}
      imageUrl={blog.imageUrl}
      description={blog.description}
      category={blog.category || "Investing"}
      readTime={blog.readTime || "6 min read"}
      readMoreLink={blog.readMoreLink}
      onReadMore={onReadMore}
      sx={{ height: "100%", maxWidth: "100%" }}
    />
  );
};

export default FeaturedBlogCard;
